import { buildRoute, noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";

export interface FilterOrdersRequest {
  area?: string;
  step?: string;
  customerOrderNoserv?: string;
  customerOrderServ?: string;
  orderIn?: string;
  serialIn?: string;
  sapWorkOrder?: string;
  orderOut?: string;
  serialOut?: string;
  document9r1?: string;
  customer?: string;
  fechaDesde?: string; // ISO date: YYYY-MM-DD
  fechaHasta?: string; // ISO date: YYYY-MM-DD
  description?: string;
  visible?: boolean;
  ownPackaging?: boolean;
  correctPackaging?: string;
  damagedPackaging?: string;
  packagingReference?: string;
  page?: number;
  size?: number;
  orderBy?: string;
  order?: "asc" | "desc";
}

export const filterOrders = async (params: FilterOrdersRequest) => {
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    const url = buildRoute(noEnvRoutes.filterOrders, cleanParams);

    const { data } = await api.get(url);
    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Ha habido un problema");
  }
};

export const getPhotoDownloadUrl = async (imageId: number): Promise<string> => {
  try {
    const url = buildRoute(noEnvRoutes.downloadPhoto, { imageId });
    const { data } = await api.get(url);
    return data.url; // DownloadUrlResponseApi.url
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(
        error.response.data?.message ?? "Error downloading image",
      );
    }
    throw new Error("Error downloading image");
  }
};

export const deletePhoto = async (imageId: number): Promise<void> => {
  try {
    const url = noEnvRoutes.deletePhoto.replace("{imageId}", String(imageId));
    await api.patch(url);
  } catch (error) {
    console.error({ error });
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data?.error ?? "Error deleting image");
    }
    throw new Error("Error deleting image");
  }
};
